import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button, { ButtonProps as MuiButtonProps } from '@mui/material/Button'
import { Launch } from '@mui/icons-material'

const ChangeSiteButton = ({
  buttonProps,
  handleChangeSiteClick
}: {
  buttonProps: MuiButtonProps
  handleChangeSiteClick: () => void
}) => {
  return (
    <Button
      {...buttonProps}
      variant="outlined"
      color="secondary"
      startIcon={<Launch />}
      onClick={handleChangeSiteClick}
    >
      <FormattedMessage id={'appLayout.changeTenantButton'} />
    </Button>
  )
}

export default ChangeSiteButton
